/**
 * For calculating covers by section, we need a key for tables that don't have a table
 * and thus don't have a section
 */
export const TABLELESS_SECTION_LABEL = 'Unassigned reservations';
export const CONDENSED_SECTION_LABEL = 'All inventory';

/**
 * We want to be able to create an object that maps a tableId to pieces of inventory,
 * so we key things by -1 for convenience with the types.
 */
export const TABLE_ID_FOR_NO_TABLE = -1;

/**
 * Fallback minimum turn time if nothing is configured
 * This should (ideally) stay in sync with the default two-top turn time
 * set in Java
 */
export const DEFAULT_MIN_TURN_TIME_MINUTES = 90;
